import type { OpenGraphDetailsGetResponseAjaxApi } from './open-graph-details.backend-model';
import type { OpenGraphDetails } from './open-graph-details.model';

export function transformOpenGraphDetails(
  response: OpenGraphDetailsGetResponseAjaxApi,
): OpenGraphDetails {
  return {
    id: response.open_graph_details.url,
    title: response.open_graph_details.title ?? undefined,
    url: response.open_graph_details.url,
    imageUrl: response.open_graph_details.image_url ?? undefined,
    siteName: response.open_graph_details.site_name ?? undefined,
    description: response.open_graph_details.description ?? undefined,
    type: response.open_graph_details.type ?? undefined,
    audioUrl: response.open_graph_details.audio_url ?? undefined,
  };
}
